import { type SEOHandle } from '@nasa-gcn/remix-seo'
import { type MetaFunction } from '@remix-run/node'
import { Link } from '@remix-run/react'
import { Button } from '#app/components/ui/button'

export const handle: SEOHandle = {
	getSitemapEntries: () => [{ route: '/digital-gift' }],
}
export const meta: MetaFunction = () => [
	{ title: 'Personalised digital gifts that fund trees | Erda' },
	{
		name: 'description',
		content:
			'Give a meaningful place on the map from $2 a year. Add a personal message and fund two trees with an Erda digital gift.',
	},
	{
		property: 'og:title',
		content: 'Personalised digital gifts that fund trees | Erda',
	},
	{
		property: 'og:description',
		content:
			'Give a meaningful place on the map from $2 a year. Add a personal message and fund two trees with an Erda digital gift.',
	},
	{ property: 'og:url', content: 'https://erda.app/digital-gift' },
]
export default function Page() {
	return (
		<article className="panel-copy">
			<h1>A place that means something.</h1>
			<p>
				Where you met. Your favourite trip. The place you call home. Turn it
				into a personal digital gift that funds trees.
			</p>
			<p className="panel-price">$2 per place, per year · Funds two trees</p>
			<Button asChild>
				<Link to="/?map=1&select=paid">Choose a place</Link>
			</Button>
			<section>
				<h2>Make it theirs</h2>
				<ol>
					<li>
						Find a meaningful place on the map and select an available place.
					</li>
					<li>Open your basket and choose to give it as a gift.</li>
					<li>
						After checkout, personalise the card and choose when to send it.
					</li>
				</ol>
			</section>
			<section>
				<h2>What they receive</h2>
				<p>
					A digital place on Erda, a personal message and a place they can make
					their own. It is a map sponsorship, not physical land or legal
					ownership.
				</p>
			</section>
			<section>
				<h2>A gift that keeps giving</h2>
				<p>
					Your subscription renews annually. Each renewal funds two more trees.
					You can manage your subscription in your account.
				</p>
				<Link to="/tree-planting">How tree planting works</Link>
			</section>
			<section>
				<h2>Start with a memory</h2>
				<nav>
					<Link to="/gifts/anniversary">An anniversary gift</Link>
					<Link to="/gifts/where-we-met">The place you first met</Link>
				</nav>
			</section>
		</article>
	)
}
